module.exports = __webpack_public_path__ + "static/media/it-large.43a26bc7.svg";